
const CONFIG = {
  gallerytest: {
    cognito: {
      USER_POOL_ID: 'us-west-2_vLjRNE0P2',
      APP_CLIENT_ID: '58gnnn21erh53l0kq85qrv9fbh',
      REGION: 'us-west-2',
      IDENTITY_POOL_ID: 'us-west-2:5741dcc0-e668-41ee-8a1b-3e9a12633ffa'
    },
    apiGateway: {
      URL: 'https://gykj33yp1c.execute-api.us-west-2.amazonaws.com/test',
      REGION: 'us-west-2'
    },
    s3: {
      BUCKET: 'tusseylandscaping/test',
      BUCKET_ROOT: 'tusseylandscaping',
      REGION: 'us-west-2'
    },
    rooturl: 'https://www.tusseylandscaping.com/outdoor-living-gallery.html',
    NODE_ENV: 'development'
  },
  tusseylandscaping: {
    cognito: {
      USER_POOL_ID: 'us-west-2_vLjRNE0P2',
      APP_CLIENT_ID: '58gnnn21erh53l0kq85qrv9fbh',
      REGION: 'us-west-2',
      IDENTITY_POOL_ID: 'us-west-2:5741dcc0-e668-41ee-8a1b-3e9a12633ffa'
    },
    apiGateway: {
      URL: 'https://jgbx8cvk55.execute-api.us-west-2.amazonaws.com/dev',
      REGION: 'us-west-2'
    },
    s3: {
      BUCKET: 'images.tusseylandscaping.com/gallery',
      BUCKET_ROOT: 'images.tusseylandscaping.com',
      REGION: 'us-west-2'
    },
    rooturl: 'https://www.tusseylandscaping.com/outdoor-living-gallery.html',
    NODE_ENV: 'production'
  },
  precisionwoodworks: {
    cognito: {
      USER_POOL_ID: 'us-west-2_jFdE3NhGL',
      APP_CLIENT_ID: '1i19dqjnlo0hr3pmd70dgftnhs',
      REGION: 'us-west-2',
      IDENTITY_POOL_ID: 'us-west-2:affece6e-b30d-46a2-a1ab-542ea0b9cbfe'
    },
    apiGateway: {
      URL: 'https://tit8u6qbh1.execute-api.us-west-2.amazonaws.com/prod',
      REGION: 'us-west-2'
    },
    s3: {
      BUCKET: 'images.precisionwood.net/gallery',
      BUCKET_ROOT: 'images.precisionwood.net',
      REGION: 'us-west-2'
    },
    rooturl: 'https://www.precisionwood.net/portfolio.html',
    NODE_ENV: 'production'
  },
  lawrukmachine: {
    cognito: {
      USER_POOL_ID: 'us-west-2_ACwNGnQa4',
      APP_CLIENT_ID: 'm8hil8lf5p6v7d9gsgevifjic',
      REGION: 'us-west-2',
      IDENTITY_POOL_ID: 'us-west-2:647b64eb-01e2-4c56-af6a-a254c4189d5e'
    },
    apiGateway: {
      URL: 'https://5fhr2ubw05.execute-api.us-west-2.amazonaws.com/prod',
      REGION: 'us-west-2'
    },
    s3: {
      BUCKET: 'images.lawrukmachine.com/gallery',
      BUCKET_ROOT: 'images.lawrukmachine.com',
      REGION: 'us-west-2'
    },
    rooturl: 'https://www.lawrukmachine.com/product-gallery.html',
    NODE_ENV: 'production'
  },
  zimmermanwildlife: {
    cognito: {
      USER_POOL_ID: 'us-west-2_6skg5e1PE',
      APP_CLIENT_ID: '2gerr0c4cl030ngrorueq0ij70',
      REGION: 'us-west-2',
      IDENTITY_POOL_ID: 'us-west-2:095b3f26-aef8-4d8a-8bcf-1e22458da429'
    },
    apiGateway: {
      URL: 'https://s36figc2j1.execute-api.us-west-2.amazonaws.com/prod',
      REGION: 'us-west-2'
    },
    s3: {
      BUCKET: 'images.zimmermanwildlife.net/gallery',
      BUCKET_ROOT: 'images.zimmermanwildlife.net',
      REGION: 'us-west-2'
    },
    rooturl: 'https://www.zimmermanwildlife.net/gallery.html',
    NODE_ENV: 'production'
  }
};

export const config = () => {
  const key = localStorage.getItem('SITE_NAME')
  return CONFIG[key]
}
export const validConfig = (key) => {
  return !!CONFIG[key]
}
